<template>
    <el-dialog
        v-if="formVisible"
        title="新增Asin"
        :visible.sync="formVisible"
        :before-close="hideForm"
        width="600px"
        append-to-body
        top="5vh">
        <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="100px">
            <el-form-item label="国家" prop="state">
                <el-select v-model="formData.state" style="width: 150px;" size="mini">
                    <el-option
                        v-for="item in $common.us_arr_normal"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{item.title}}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Asin">
                <el-input v-model="formData.asin" placeholder="请输入Asin" auto-complete="off"
                          style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item label="海关编码">
                <el-input v-model="formData.customs_code" class="" placeholder="请输入海关编码" auto-complete="off"
                          style="width: 300px; "></el-input>
            </el-form-item>
            <el-form-item label="重">
                <el-input v-model="formData.weight" class="" placeholder="请输入重" auto-complete="off"
                          style="width: 300px; "></el-input>
            </el-form-item>

            <el-form-item label="单价">
                <el-input-number
                    v-model="formData.price"
                    style="width: 300px;"
                    :min="0.00"
                    :step="0.01"
                    size="mini"
                    placeholder="请输入单价"
                >
                </el-input-number>
            </el-form-item>

            <el-form-item label="品牌">
                <el-input v-model="formData.brand" class="" placeholder="请输入品牌" auto-complete="off"
                          style="width: 300px; "></el-input>
            </el-form-item>

            <el-form-item label="材质">
                <el-input v-model="formData.material" class="" placeholder="请输入材质" auto-complete="off"
                          style="width: 300px; "></el-input>
            </el-form-item>

            <el-form-item label="用途">
                <el-input v-model="formData.purpose" class="" placeholder="请输入用途" auto-complete="off"
                          style="width: 300px; "></el-input>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click.native="hideForm" size="mini">取消</el-button>
            <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" size="mini">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {logistics_asin_add,} from '@/api/advAnalys/advAnalys.js'

    export default {
        name: 'addAsin',
        data() {
            return {
                formLoading: false,
                formVisible: false,
                formRules: {
                    state: [
                        {required: true, message: '请选择收件国家', trigger: 'blur'}
                    ]
                },
                formData: {
                    state: '',
                    asin: '',
                    customs_code: '',
                    weight: '',
                    price: '',
                    brand: '',
                    purpose: '',
                    material: '',
                },
            }
        },
        methods: {
            openModal() {
                this.formVisible = true
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible
                // 清空表单
                this.$refs['dataForm'].resetFields()
                this.initFormData()
                return true
            },
            initFormData() {
                this.formData = {
                    state: '',
                    asin: '',
                    customs_code: '',
                    weight: '',
                    price: '',
                    brand: '',
                    purpose: '',
                    material: '',
                }
            },
            formSubmit() {
                this.$refs['dataForm'].validate(valid => {
                    if (valid) {
                        this.formLoading = true
                        let data = Object.assign({}, this.formData)
                        logistics_asin_add(data).then(response => {
                            if (response.code == 0) {
                                this.hideForm()
                                this.$emit('addAsin')
                            } else {
                                this.$message.error(response.message)
                            }
                        }).catch(() => {
                            this.formLoading = false
                        }).finally(() => {
                            this.formLoading = false
                        })
                    }
                })
            },

        }
    }
</script>
